import { ApiCodes } from './error-code';

class ApiManager {
  

  async request_v1(apiPath, params = {}, pathParams = {}, method = 'POST') {
    const headers = {
      'Content-Type': 'application/json',
      // "m_uid": mUid,
      // "m_access_token": mAccessToken,
    };
    
    var domain = window['runtime_configs'].REACT_APP_API_ENDPOINT;
    let url = domain +  apiPath;
    if (method === 'GET' && pathParams) {
      url = `${url}/${pathParams}`
    }
    if (method === 'GET' && params) {
      url = new URL(url);
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== ''){
          if (Array.isArray(params[key])) {
            return params[key].map((value) => url.searchParams.append(key, value))
          }
          return url.searchParams.append(key, params[key])
        }
      })
    }
    var body =  method === 'GET' ? undefined : JSON.stringify(params);
    return fetch(url, {
      method: method, 
      headers: headers,
      credentials: 'include',
      body: body
    })
      .then(resp => {
        console.log('------------------', resp);
        if(resp.status != 200){
          throw new Error("Server responds with error!");
        }
        return resp.json();
      })
      .then(resp => {
        
        return ({ ...resp })
      })
      .catch(error => {
        console.log('------------------1-----', error);
          throw error;
        }
      );
  }
}
export default ApiManager;
